import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './components/Login.vue'
import Test from './components/test.vue'
// import Home from './components/home.vue'
import Instances from './components/instances.vue'
import Algorithms from './components/algorithms.vue'
import Calc from './components/calc.vue'
import Train from './components/train.vue'
import MyInstance from './components/myInstance.vue'
import MyCalc from './components/myCalc.vue'
import forgetPwd from './components/forgetPwd.vue'
import myHelp from './components/myHelp.vue'
import setUrl from './components/setBaseUrl.vue'
import mySetting from './components/setting.vue'
import qywxLogin from './components/qywxLogin.vue'
import changePwd from './components/me/changePwd.vue'
import setApi from './components/me/setAPI.vue'
// import Main from './components/main.vue'
Vue.use(VueRouter)

const routes = [
  // { path: '/', component: Main },
  { path: '/', redirect: '/instances' },
  { path: '/instances', component: Instances },
  { path: '/algorithms', component: Algorithms },
  { path: '/calc/:instanceId', component: Calc },
  { path: '/train/:algorithmId', component: Train },
  { path: '/myInstances', component: MyInstance },
  { path: '/myCalc', component: MyCalc },
  { path: '/forgetPwd', component: forgetPwd },
  { path: '/help/:docName', component: myHelp },
  { path: '/setBaseUrl/:baseUrl', component: setUrl },
  { path: '/qywxLogin/:token/:uname', component: qywxLogin },
  { path: '/login', component: Login },
  { path: '/test', component: Test },
  {
    path: '/setting',
    component: mySetting,
    children: [
      { path: 'changePwd', component: changePwd },
      { path: 'setAPI', component: setApi }

    ]
  },
  {
    path: '/admin',
    component: () => import('./components/admin/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
